export default __webpack_public_path__ + "static/media/notLearned.9ca5e268.svg";